import { Component } from "react"
import PropTypes from "prop-types"
import { Button } from "@mui/material"
import ExperimentsList from "../experiments-list"
import CompareSearch from "../compare-search"

class AddOptions extends Component {
  static propTypes = {
    openDialog: PropTypes.func.isRequired,
    trackExperimentTypeSelection: PropTypes.func.isRequired,
    account: PropTypes.string.isRequired,
    toggleSaveExperiment: PropTypes.func.isRequired,
    modelId: PropTypes.string.isRequired,
    portfolio: PropTypes.string.isRequired,
    searchItemsActions: PropTypes.object.isRequired,
    disableSearchResult: PropTypes.func.isRequired,
    isOpPro: PropTypes.bool.isRequired,
  }

  openSearch = () => {
    const { account, openDialog, modelId, portfolio, searchItemsActions, disableSearchResult } = this.props
    openDialog({
      title: "Search For Comparison",
      content: <CompareSearch account={account} modelId={modelId} resourceType="PORTFOLIO" resourceId={portfolio} itemsActions={searchItemsActions} disableSearchResult={disableSearchResult} />,
    })
  }

  openExperimentsList = () => {
    const { openDialog, account, portfolio, toggleSaveExperiment, trackExperimentTypeSelection, isOpPro } = this.props
    openDialog({
      title: "Add experiment",
      content: <ExperimentsList trackExperimentTypeSelection={trackExperimentTypeSelection} toggleSaveExperiment={toggleSaveExperiment} account={account} portfolio={portfolio} openSearch={this.openSearch} isOpPro={isOpPro} />,
    })
  }

  render() {
    return <Button color="primary" onClick={this.openExperimentsList} variant="text">
      + Add Experiment
    </Button>
  }
}

export default AddOptions
